import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ItemModuleDto} from '../../../../Models/Module/module.interface';

@Component({
  selector: 'app-favorites-modules-swiper',
  templateUrl: './favorites-modules-swiper.component.html',
  styleUrls: ['./favorites-modules-swiper.component.scss'],
  standalone: false
})
export class FavoritesModulesSwiperComponent {
  @Input() favoritesItems: ItemModuleDto[] = [];
  @Input() showEmptyMessage: boolean = false;

  @Output() actionButton: EventEmitter<ItemModuleDto> = new EventEmitter<ItemModuleDto>;
  @Output() setFavorites: EventEmitter<void> = new EventEmitter<void>;
}
